import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import SidebarMenu from '../../components/SidebarMenu';
import Footer from '../../components/Footer';

function AppLayout({ children }) {
	const { pathname } = useLocation();

	return (
		<Box sx={{ display: 'flex', minHeight: '100vh' }}>
			<SidebarMenu />
			<Box
				component="main"
				sx={{
					flexGrow: 1,
					display: 'flex',
					flexDirection: 'column',
					width: { xs: '100%', sm: 'auto' },
					maxWidth: '100%',
					minHeight: '100vh',
				}}
			>
				<Grid
					sx={{
						display: 'flex',
						flexDirection: 'column',
						flexGrow: 1,
						padding: {
							xs: '4.85rem 1rem 1rem 1rem',
							sm: '5.35rem 1.07rem 1.07rem 1rem',
						},
					}}
				>
					{children}
				</Grid>
				{pathname === '/orders' ||
				pathname === '/products' ||
				pathname.includes() === '/search/' ? (
					''
				) : (
					<Box sx={{ mt: 'auto' }}>
						<Footer />
					</Box>
				)}
			</Box>
		</Box>
	);
}

AppLayout.propTypes = {
	children: PropTypes.node,
};

export default AppLayout;
